/**
 * Fast deterministic hash using MurmurHash3-style mixing.
 * Given the same inputs, always produces the same output.
 */
export function hash(seed, ...values) {
    let h = seed | 0;
    for (const v of values) {
        let k = (v | 0) * 0xcc9e2d51;
        k = (k << 15) | (k >>> 17);
        k *= 0x1b873593;
        h ^= k;
        h = (h << 13) | (h >>> 19);
        h = h * 5 + 0xe6546b64;
    }
    h ^= values.length;
    h ^= h >>> 16;
    h = Math.imul(h, 0x85ebca6b);
    h ^= h >>> 13;
    h = Math.imul(h, 0xc2b2ae35);
    h ^= h >>> 16;
    return h >>> 0;
}
export function hashFloat(seed, ...values) {
    return (hash(seed, ...values) & 0x7fffffff) / 0x7fffffff;
}
export function hashRange(seed, min, max, ...values) {
    return min + hashFloat(seed, ...values) * (max - min);
}
export function hashInt(seed, min, max, ...values) {
    return Math.floor(hashRange(seed, min, max + 1, ...values));
}
export class SeededRandom {
    state;
    constructor(seed) {
        this.state = seed | 0;
    }
    next() {
        this.state = Math.imul(this.state, 1664525) + 1013904223;
        return ((this.state >>> 0) & 0x7fffffff) / 0x7fffffff;
    }
    nextInt(min, max) {
        return Math.floor(min + this.next() * (max - min + 1));
    }
    nextFloat(min, max) {
        return min + this.next() * (max - min);
    }
    pick(arr) {
        return arr[Math.floor(this.next() * arr.length)];
    }
}
//# sourceMappingURL=hash.js.map